import { useNavigate, useLocation } from 'react-router-dom'
import { useEffect } from 'react'

/**
 * Custom hook to register the last visited non-settings, non-profile page
 * and provide a back navigation function that dynamically returns there.
 */
export function useNavigationTracker() {
  const location = useLocation()

  useEffect(() => {
    const path = location.pathname
    const isExcluded = 
      path.includes('/settings') || 
      path.includes('/profile') || 
      path.includes('/change-password') || 
      path.includes('/password')
    
    if (!isExcluded) {
      sessionStorage.setItem('lastNonSettingsPage', path + location.search)
    }
  }, [location])
}

export function useGoBack(fallback: string) {
  const navigate = useNavigate()
  
  return () => {
    const lastPage = sessionStorage.getItem('lastNonSettingsPage')
    if (lastPage) {
      navigate(lastPage)
    } else {
      navigate(fallback)
    }
  }
}
